<div class="modal-header"><h2 class="modal-title">Series Data</h2></div>
<div class="modal-body">
  @if (true) {
    <div>
      <dx-data-grid #grid [dataSource]="generalFund" keyExpr="id" [columnAutoWidth]="false" [height]="500">
        <dxi-column dataField="name" cellTemplate="nameTemplate" width="300">
          <div *dxTemplate="let d of 'nameTemplate'">
            @if (executive || thanksgiving) {
              <a>{{ d.value || '(blank)' }}</a>
            }
            @if (!executive && !thanksgiving) {
              <a [routerLink]="'/giving/batches/' + d.data.id">{{ d.value || '(blank)' }}</a>
            }
          </div>
        </dxi-column>
        <dxi-column dataField="quickBooksAccount" caption="Acct" width="50"></dxi-column>
        <dxi-column dataField="bagNumber" caption="Bag" width="50" [visible]="!thanksgiving"></dxi-column>
        <dxi-column dataField="totalAmount" dataTye="number" [format]="{ type: 'currency', precision: 2 }" width="150" cssClass="align-right-pad"></dxi-column>
        <dxi-column dataField="date" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'" [visible]="!thanksgiving"></dxi-column>
        <dxi-column dataField="statusName" caption="Status" width="100" [visible]="!thanksgiving"></dxi-column>
        <!-- <dxi-column dataField="personName" dataType="text" caption="Box" width="150"></dxi-column>
        <dxi-column dataField="givingName" caption="Type" width="100"></dxi-column>
        <dxi-column dataField="amount" dataType="number" [format]="{ type: 'currency', precision: 2 }" width="150" cssClass="align-right-pad"></dxi-column>
        <dxi-column dataField="timeStamp" caption="Entered" dataType="date" width="150" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column> -->
        <!-- <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations> -->
        <!-- <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="batch-list-grid"></dxo-state-storing> -->
        <!-- <div *dxTemplate="let data of 'toolbarButtons'">
        <button type="button" *ngIf="true" class="btn btn-primary">Add Contribution</button>
      </div> -->
      <dxo-export [enabled]="true"></dxo-export>
      <dxo-summary>
        <dxi-total-item column="totalAmount" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
        <dxo-export [enabled]="true"></dxo-export>
      </dxo-summary>
    </dx-data-grid>
  </div>
}
</div>
<div class="modal-footer">
  <!-- <button type="button" class="btn btn-success">Save</button> -->
  <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
